import { useTranslation } from 'react-i18next';

import Chip from '@/components/Chip';
import { SUBSCRIPTION_STATUS } from '@/models/subscription';
import { cn } from '@/utils';

const statuses = {
	[SUBSCRIPTION_STATUS.ACTIVE]: {
		textKey: 'active',
		color: 'success',
		textColor: 'text-green'
	},
	[SUBSCRIPTION_STATUS.TRIALING]: {
		textKey: 'active',
		color: 'success',
		textColor: 'text-green'
	},
	[SUBSCRIPTION_STATUS.CANCELED]: {
		textKey: 'canceled',
		color: 'default',
		textColor: 'text-grey-400'
	},
	[SUBSCRIPTION_STATUS.EXPIRED]: {
		textKey: 'expired',
		color: 'error',
		textColor: 'text-red'
	},
	[SUBSCRIPTION_STATUS.PAST_DUE]: {
		textKey: 'past_due',
		color: 'error',
		textColor: 'text-red'
	},
	[SUBSCRIPTION_STATUS.PENDING]: {
		textKey: 'pending',
		color: 'warning',
		textColor: 'text-orange'
	}
};

function PlanStatusChip({ status, cancellationRequestAt }) {
	const { t } = useTranslation();

	let parsedStatus = statuses[status];

	if (cancellationRequestAt) {
		parsedStatus = statuses[SUBSCRIPTION_STATUS.CANCELED];
	}

	// fallback chip for not listed statuses
	if (!parsedStatus) {
		parsedStatus = {
			textKey: status,
			color: 'default',
			textColor: 'text-grey-400'
		};
	}

	return (
		<Chip bgColor={parsedStatus.color}>
			<p
				className={cn(
					'text-xs font-semibold capitalize leading-5',
					parsedStatus.textColor
				)}
			>
				{t(`billing.subscription.statuses.${parsedStatus.textKey}`)}
			</p>
		</Chip>
	);
}

export default PlanStatusChip;
